import { useContext, useState, useEffect } from 'react';
import './Settings.css';
import SlButton from '@shoelace-style/shoelace/dist/react/button/index.js';
import { appContext, AppContext } from '../../../context/AppContext';
import { useTranslation } from 'react-i18next';
import i18n from '../../../../i18n/i18n';
import { Heading } from '../../base/Heading/Heading';
import { Select } from '@anticatrade/shared';

const Settings = () => {
	const [language, setLanguage] = useState<string>();
	const [isSaving, setIsSaving] = useState<boolean>(false);

	const { t } = useTranslation();
	const { api, setIsLoadingState, showStatus, handleError, settings } = useContext(
		appContext as React.Context<AppContext>,
	);

	useEffect(() => {
		if (settings != null) {
			setLanguage(settings.languageCode);
		}
	}, []);

	const onChangeLanguage = (e: any) => {
		setLanguage(e.target.value);
	};

	const onSaveSettings = async () => {
		setIsSaving(true);
		const s = {
			languageCode: language!,
		};
		try {
			await api.updateMerchantSettings(s);
		} catch (err) {
			handleError(err as Error);
			return;
		}
		i18n.changeLanguage(language);
		document.documentElement.lang = language!;
		setIsSaving(false);
		setIsLoadingState(true);
		showStatus({
			variant: 'success',
			icon: 'check-circle',
			text: t('Settings saved successfully'),
		});
	};

	return (
		<div className='settings'>
			<Heading left={<h1 className='settings__heading-title'>{t('Settings')}</h1>} />
			<div className='settings__form wrapped'>
				<Select
					label={t('Language')}
					value={language === undefined ? '' : language}
					onChange={onChangeLanguage}
					options={[
						{
							key: 'it',
							name: t('Italian'),
							value: 'it',
						},
						{
							key: 'en',
							name: t('English'),
							value: 'en',
						},
						{
							key: 'fr',
							name: t('French'),
							value: 'fr',
						},
					]}
				/>
			</div>
			<SlButton
				className='settings__save-button'
				variant='primary'
				onClick={onSaveSettings}
				loading={isSaving}
			>
				{t('Save')}
			</SlButton>
		</div>
	);
};

export { Settings };
